import React, { Component } from 'react';
import { loadProjects } from './requests';
import { Jumbotron, Button,
    Card, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle } from 'reactstrap';

export class ClientFaqPage extends Component {

  constructor(props) {
    super(props);
    this.state = {Projects: []};
  }

  async componentDidMount() {
    const Projects = await loadProjects();
    this.setState({Projects});
  }

  render() {
    return (
      <div>
          <br/>
          <br/>

              <h1 className="display-3">FAQ</h1>

          <div className="row">
              <div className="col-sm-4">
                  <Card>
                      <CardImg top width="100%" src="https://placeholdit.imgix.net/~text?txtsize=33&txt=318%C3%97180&w=318&h=180" alt="Card image cap" />
                      <CardBody>
                          <CardTitle>Transparency</CardTitle>
                          <CardSubtitle>Project Updates "clearly" as they should be</CardSubtitle>
                          <CardText>View full project details quickly and stay in the loop with email alerts.</CardText>
                          <Button>More</Button>
                      </CardBody>
                  </Card>
              </div>

              <div className="col-sm-4">
                  <Card>
                      <CardImg top width="100%" src="https://placeholdit.imgix.net/~text?txtsize=33&txt=318%C3%97180&w=318&h=180" alt="Card image cap" />
                      <CardBody>
                          <CardTitle>Development Processes</CardTitle>
                          <CardSubtitle>How it works</CardSubtitle>
                          <CardText>How we'll handle your project. See our processes and procedures.</CardText>
                          <Button>Button</Button>
                      </CardBody>
                  </Card>
              </div>

            <div className="col-sm-4">
                  <Card>
                      <CardImg top width="100%" src="https://placeholdit.imgix.net/~text?txtsize=33&txt=318%C3%97180&w=318&h=180" alt="Card image cap" />
                      <CardBody>
                          <CardTitle>Show Case</CardTitle>
                          <CardSubtitle>Card subtitle</CardSubtitle>
                          <CardText>Here are some projects we've completed in the past. Take a look.</CardText>
                          <Button>Button</Button>
                      </CardBody>
                  </Card>
              </div>

          </div>

          <br/>
          <br/>

        <Jumbotron>
              <h1 className="display-5">Get in Touch</h1>
              <p className="lead">This is a simple hero unit, a simple Jumbotron-style component for calling extra attention to featured content or information.</p>
              <hr className="my-2" />
              <p>It uses utility classes for typgraphy and spacing to space content out within the larger container.</p>
          </Jumbotron>

          <br/>
          <br/>

      </div>
    );
  }
}
